import { formattedPhone } from './formatted-phone';
import { currency } from './currency';
import { date } from './date';
import { frequency } from './frequency';
import { fullName } from './full-name';
import { titleCase } from './title-case';

// eslint-disable-next-line import/prefer-default-export
export const lsFilters = {
    currency,
    date,
    formattedPhone,
    frequency,
    fullName,
    titleCase,

    templateFilters: {
        currency(amount, emptyDisplay = '- - - -', trimTrailingZeros = false) {
            return currency({ amount, emptyDisplay, trimTrailingZeros });
        },
        date(value, format) {
            return date({ date: value, format });
        },
        formattedPhone(phone) {
            return formattedPhone({ phone });
        },
        frequency(cycle, lowercase = false) {
            return frequency({ cycle, lowercase });
        },
        fullName(user, withType = false) {
            return fullName({ user, withType });
        },
        titleCase(text) {
            return titleCase({ text });
        },
    },
};
